import { connect } from 'react-redux';
import { setIsAuthenticated, setSplashScreen } from 'modules/app';
import { bindActionCreators } from 'redux';
import { goHome, resetAll } from 'modules/steps/actions';
import { resetContext, logOut } from 'store/globalState/global';
import Logout from '../components/Logout';

const mapStateToProps = () => ({
});

function mapDispatchToProps(dispatch) {
  return {
    setIsAuthenticated: bindActionCreators(setIsAuthenticated, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
    setSplashScreen: bindActionCreators(setSplashScreen, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    logOut: bindActionCreators(logOut, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/routes/Logout/container/index.js